// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7897) return "sgs-stats/js/7897.1ce429cc870e575a.js";
	if (chunkId === 7520) return "sgs-stats/js/7520.2b5096d5c1b5e71e.js";
	// return url for filenames based on template
	return undefined;
};